import { env } from "./env";

/**
 * Parses a feature flag key located in the environment variables
 * @returns Whether the feature flag is active
 */
function flag(key: keyof ImportMetaEnv): boolean {
  return env[key] === "1";
}

function getTemporaryUrlFlag(key: string): boolean {
  const location = globalThis.window.location;

  const searchParams = new URLSearchParams(location.search);

  return searchParams.get(key) === "1";
}

/**
 * Feature flags
 */
export const featureFlags = {
  enableUsersCrud: flag("VITE_ENABLE_USERS_CRUD"),
  enableRegistrationPendencyPasswordField: flag(
    "VITE_ENABLE_REGISTRATION_PENDENCY_PASSWORD_FIELD",
  ),
  enableAggregateOfferDocumentType: flag(
    "VITE_ENABLE_AGGREGATE_OFFER_DOCUMENT_TYPE",
  ),
  enableRefinCard: flag("VITE_ENABLE_REFIN_CARD"),
  enableCorrespondenteBanqueiro: flag("VITE_ENABLE_CORRESPONDENTE_BANQUEIRO"),
  enableInsurancesVisualization: flag("VITE_ENABLE_INSURANCES_VISUALIZATION"),
  enableDocumentTypeOthers: flag("VITE_ENABLE_DOCUMENT_TYPE_OTHERS"),
  enableValidateCustomerRestrictions: flag(
    "VITE_ENABLE_VALIDATE_CUSTOMER_RESTRICTIONS",
  ),
  /** Habilita coluna de data do último status para Happy */
  enableContractsLastStatusDateHappy: flag(
    "VITE_ENABLE_CONTRACTS_LAST_STATUS_DATE_HAPPY",
  ),

  //** Habilita novo layout da tabela e Retenção */
  enableContractsRetentionLayout: flag(
    "VITE_ENABLE_CONTRACTS_RETENTION_LAYOUT",
  ),

  /** Habilita coluna de data do último status para Caixa */
  enableContractsLastStatusDateCef: flag(
    "VITE_ENABLE_CONTRACTS_LAST_STATUS_DATE_CEF",
  ),
  enablePortRefinNegativeMargin: flag("VITE_ENABLE_PORT_REFIN_NEGATIVE_MARGIN"),
  enableNestedDocuments: flag("VITE_ENABLE_NESTED_DOCUMENTS"),
  enableLoginBgAdjustments: flag("VITE_ENABLE_LOGIN_BG_ADJUSTMENTS"),
  enableLegalRepresentativeImprovements: flag(
    "VITE_ENABLE_LEGAL_REPRESENTATIVE_IMPROVEMENTS",
  ),
  enableValidateEspecieAndCpf: flag("VITE_ENABLE_VALIDATE_ESPECIE_AND_CPF"),
  enableIdentificationEmployeePassword: flag(
    "VITE_ENABLE_IDENTIFICATION_EMPLOYEE_PASSWORD",
  ),
  enableMinorLegalRepresentative: flag(
    "VITE_ENABLE_MINOR_LEGAL_REPRESENTATIVE",
  ),
  enableImageDocumentsRequirementsToUpload: flag(
    "VITE_ENABLE_IMAGE_DOCUMENTS_REQUIREMENTS_TO_UPLOAD",
  ),
  enableNewInstallmentFields: flag("VITE_ENABLE_NEW_INSTALLMENT_FIELDS"),
  enableContractCardUpadated: flag("VITE_CONTRACT_CARD_UPADATED"),
  enableCardTracking: flag("VITE_ENABLE_CONTRACTS_CARD_TRACKING"),
  enableSimulationSelectFieldInstallments: flag(
    "VITE_ENABLE_SIMULATION_SELECT_FIELD_INSTALLMENTS",
  ),
  /* document status column */
  enableContractsDocumentStatus: flag("VITE_ENABLE_CONTRACTS_DOCUMENT_STATUS"),
  enableContractsOrderTitle: flag("VITE_ENABLE_CONTRACTS_ORDER_TITLE"),

  /** WHIT-583 */
  enableSeguroPrestamista: flag("VITE_ENABLE_SEGURO_PRESTAMISTA"),
  enableSeguroPrestamistaPortRefin: flag(
    "VITE_ENABLE_SEGURO_PRESTAMISTA_PORT_REFIN",
  ),
  enableSeguroPrestamistaRefin: flag("VITE_ENABLE_SEGURO_PRESTAMISTA_REFIN"),
  enableTaxasEspeciais: flag("VITE_ENABLE_SPECIAL_TAXES"),
  enableCancelarSeguroCard: flag("VITE_ENABLE_CANCEL_SEGURO_CARD"),

  /**WHIT-786: Habilita tipo de produto "Receba" */
  enableProductReceba: flag("VITE_ENABLE_PRODUCT_RECEBA"),

  /**CORE-1531: Habilita campos sem validação */
  enableFieldWithoutValidation: flag("VITE_ENABLE_FIELD_WITHOUT_VALIDATION"),

  /** Habilita envio criptografado de credenciais de login */
  enableEncryptCredentials: flag("VITE_ENABLE_ENCRYPT_CREDENTIALS"),

  enablePrivateConsigLoan: flag("VITE_ENABLE_PRIVATE_CONSIG"),
  enableSendIp: flag("VITE_ENABLE_SEND_IP"),

  /** TSK-294: Habilita modal de pré-visualização de pdfs por dentro da aplicação */
  enablePdfPreview: flag("VITE_ENABLE_PDF_PREVIEW"),

  /** Habilita correção de dados bancários para o produto de consignado privado  */
  enablePrivateConsigBankData: flag("VITE_ENABLE_PRIVATE_CONSIG_BANK_DATA"),

  /** HO-2251: Habilita consulta e seleção de contratos na simulação do produto Portabilidade+Refinanciamento */
  enableContractSelectPortRefin: flag("VITE_ENABLE_CONTRACT_SELECT_PORT_REFIN"),

  /** HO-2262: Habilita consulta e seleção de contratos na simulação do produto Portabilidade */
  enableContractSelectPort: flag("VITE_ENABLE_CONTRACT_SELECT_PORT"),

  /** HO-2317: Habilita seleção e exibição de seguros na simulação do produto Consignado Privado */
  enablePrivateConsigInsurance: flag("VITE_ENABLE_PRIVATE_CONSIG_INSURANCE"),

  /** HO-2329: Habilita nova versão da seleção e exibição de seguros na simulação do produto Consignado Privado */
  enablePrivateConsigInsuranceV2: flag(
    "VITE_ENABLE_PRIVATE_CONSIG_INSURANCE_V2",
  ),

  /** CFE-106: Habilita nova mensagem para benefício bloqueado para Happy (Port, Port+Refin e Margem Livre) */
  enableNewBenefitBlockedMessage: flag(
    "VITE_ENABLE_NEW_BENEFIT_BLOCKED_MESSAGE",
  ),

  /** CFE-106: Habilita nova mensagem de erro no envio de documentos em analfabetos para Happy (Margem Livre) */
  enableNewIlliterateErrorMessage: flag(
    "VITE_ENABLE_NEW_ILLITERATE_ERROR_MESSAGE",
  ),

  /** CFE-123 Habilita nova jornada do consignado privado englobando api v2 via BFF */
  enablePrivateConsigV2: flag("VITE_ENABLE_PRIVATE_CONSIG_V2"),

  /** CEF Flags */
  enableJourneyAfterIn100Success: flag(
    "VITE_ENABLE_JOURNEY_AFTER_IN100_SUCCESS",
  ),
  enableEligibilityCef: flag("VITE_ENABLE_ELIGIBILITY_CEF"),
  enableCaixaTheme: flag("VITE_ENABLE_CAIXA_THEME"),
  enableMaximumInstallmentCef: flag("VITE_ENABLE_MAXIMUM_INSTALLMENT_CEF"),
  enableBenefitStatusMessageCef: flag("VITE_ENABLE_BENEFIT_STATUS_MESSAGE_CEF"),
  enableDelayedPhysicalSignatureCef: flag(
    "VITE_ENABLE_DELAYED_PHYSICAL_SIGNATURE_CEF",
  ),
  enableIncreaseMarginCef: flag("VITE_ENABLE_INCREASE_MARGIN_CEF"),
  enableCheckIn100AuthorizationCef: flag(
    "VITE_ENABLE_CHECK_IN100_AUTHORIZATION_CEF",
  ),
  enableDocumentTypeRestrictionCef: flag(
    "VITE_ENABLE_DOCUMENT_TYPE_RESTRICTION_CEF",
  ),
  enableProductTypeContext: flag("VITE_ENABLE_PRODUCT_TYPE_CONTEXT"),
  enableAcceptTermsCef: flag("VITE_ENABLE_ACCEPT_TERMS_CEF"),
  enableLoginMfaCef: flag("VITE_ENABLE_LOGIN_MFA_CEF"),
  enableInssRefinancingCef: flag("VITE_ENABLE_INSS_REFINANCING_CEF"),
  enablePrivateConsigCef: flag("VITE_ENABLE_PRIVATE_CONSIG_CEF"),
  enableRefinancingCefSimulationV2: flag(
    "VITE_ENABLE_REFINANCING_CEF_SIMULATION_V2",
  ),
  enableBenefitBlockedMargin: flag("VITE_ENABLE_BENEFIT_BLOCKED_MARGIN"),
  enableFuraFilaIn100: flag("VITE_ENABLE_FURA_FILA_IN100"),
  enableNewPassRules: flag("VITE_ENABLE_NEW_PASS_RULES_CEF"),
  enableGetApiBank: flag("VITE_ENABLE_GET_API_BANK"),
  enableCrossSellPortRefin: flag("VITE_ENABLE_CROSS_SELL_PORT_REFIN"),
  enableBatchTypingMarginIncrease: flag("VITE_ENABLE_BATCH_TYPING"),
  enableModalUnavailabilityCef: flag("VITE_ENABLE_MODAL_UNAVAILABILITY_CEF"),
  enableTrainingInformativeModalHappy: flag(
    "VITE_ENABLE_TRAINING_INFORMATIVE_MODAL_HAPPY",
  ),
  enableMotherNameInfoCef: flag("VITE_ENABLE_MOTHER_NAME_INFO_CEF"),
  enableCheckIn100AuthorizationBeforeBureauCef: flag(
    "VITE_ENABLE_CHECKIN100_AUTHORIZATION_BEFORE_BUREAU_CEF",
  ),
  enableLayoutV2: flag("VITE_ENABLE_LAYOUT_V2"),
  enableServicesPageV2: flag("VITE_ENABLE_SERVICESPAGE_V2"),
  enableDailyContracts: flag("VITE_ENABLE_DAILY_CONTRACTS"),
  enableDataprevInfoPrivateConsig: flag(
    "VITE_ENABLE_DATAPREVINFO_PRIVATECONSIG",
  ),
  enableIN100StepV2:
    flag("VITE_ENABLE_IN100_STEP_V2") || getTemporaryUrlFlag("enableV2"),
  enableFreeMarginSimulationV2: flag("VITE_ENABLE_FREE_MARGIN_SIMULATION_V2"),
  enableStepsLayoutV2: flag("VITE_ENABLE_STEPS_LAYOUT_V2"),
  enablePortRefinManualIn100: flag("VITE_ENABLE_PORT_REFIN_MANUAL_IN100"),
  enableSupportMaterials: flag("VITE_ENABLE_SUPPORT_MATERIALS"),
  enableDIBField: flag("VITE_ENABLE_DIB_FIELD"),

  // CFE-147: Habilita busca de CEP no step de endereço de margem livre CEF
  // Em caso de novo endereço ou de ausência de endereço cadastrado
  enableCepSearchCepInTheAddressStepCef: flag(
    "VITE_ENABLE_CEP_SEARCH_CEP_IN_THE_ADDRESS_STEP_CEF",
  ),

  //CFE-186: Habilita aba de treinamento no sidebar para Happy e Caixa
  enableTrainingTab: flag("VITE_ENABLE_TRAINING_TAB"),

  //CFE-157: Habilita aba de Não me Perturbe no sidebar para Happy
  enableDoNotDisturbTab: flag("VITE_ENABLE_DO_NOT_DISTURB_TAB"),

  //CFE-157: Habilita mensagem de alerta Não me Perturbe no Step de Consulta IN100 para Happy
  enableDoNotDisturbWarningMessage: flag(
    "VITE_ENABLE_DO_NOT_DISTURB_WARNING_MESSAGE",
  ),

  //CFE-209: Habilita aba de Não me Perturbe no sidebar para Caixa
  enableDoNotDisturbTabCef: flag("VITE_ENABLE_DO_NOT_DISTURB_TAB_CEF"),
  enableRegistrationDataConsult: flag("VITE_ENABLE_REGISTRATION_DATA_CONSULT"),

  //CFE-249: Habilita o campo de representante legal
  enableRepresentativeLegalField: flag(
    "VITE_ENABLE_REPRESENTATIVE_LEGAL_FIELD_V2",
  ),
  enableLinkValidationCef: flag("VITE_ENABLE_LINK_VALIDATION_CEF"),
} as const;
